var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import SelectDepartment from "~/components/business-component/select-department.vue";
import { MENU_CHANNEL } from '../../config/enum.config';
import { State } from "vuex-class";
import { CaseRepaymentService } from '~/services/domain-service/case-repayment.service';
import RepaymentConfirmationDetail from '~/components/case-import/repayment-confirmation-detail.vue';
var RepaymentConfirmation = /** @class */ (function (_super) {
    __extends(RepaymentConfirmation, _super);
    function RepaymentConfirmation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            collectorRealName: '',
            caseNumber: '',
            principalId: '',
            deptId: '',
            createTime: [],
            entryTime: [],
            manualConfirmDate: [],
            repayAmount: { min: '', max: '' },
            confirmState: '',
            manualConfirmRealName: '',
            repaymentAcctname: '',
            repaymentAcctno: '',
            receiveAcctname: '',
            receiveAcctno: ''
        };
        _this.rowData = {};
        _this.dialog = false;
        _this.dataSet = [];
        return _this;
    }
    RepaymentConfirmation.prototype.departemntChange = function (id, code) { };
    RepaymentConfirmation.prototype.handleResetForm = function () {
        this.model.repayAmount = { min: '', max: '' };
    };
    RepaymentConfirmation.prototype.refreshData = function () {
        var _this = this;
        this.caseRepaymentService.getAllPaymentConfirmationList(this.paramsHandler(), this.pageService, this.sortService).subscribe(function (data) {
            _this.dataSet = data || [];
        });
    };
    RepaymentConfirmation.prototype.paramsHandler = function () {
        var params = __assign({}, this.model);
        params.repayAmountMin = this.model.repayAmount.min;
        params.repayAmountMax = this.model.repayAmount.max;
        params.createTimeMin = this.model.createTime.length ? this.$filter.dateTimeFormat(this.model.createTime[0]) : '';
        params.createTimeMax = this.model.createTime.length ? this.$filter.dateTimeFormat(this.model.createTime[1]) : '';
        params.entryTimeMin = this.$filter.dateRanageFormat(this.model.entryTime).start;
        params.entryTimeMax = this.$filter.dateRanageFormat(this.model.entryTime).end;
        params.manualConfirmDateMin = this.model.manualConfirmDate.length ? this.$filter.dateTimeFormat(this.model.manualConfirmDate[0]) : '';
        params.manualConfirmDateMax = this.model.manualConfirmDate.length ? this.$filter.dateTimeFormat(this.model.manualConfirmDate[1]) : '';
        delete params.repayAmount;
        delete params.entryTime;
        delete params.createTime;
        delete params.manualConfirmDate;
        return params;
    };
    RepaymentConfirmation.prototype.created = function () {
        this.refreshData();
    };
    RepaymentConfirmation.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Repayment_confirmation,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    RepaymentConfirmation.prototype.onClickSure = function (row) {
        this.dialog = true;
        this.rowData = row;
    };
    RepaymentConfirmation.prototype.onClickDetial = function (row) {
        this.dialog = true;
        this.rowData = row;
    };
    __decorate([
        Dependencies(PageService)
    ], RepaymentConfirmation.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], RepaymentConfirmation.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseRepaymentService)
    ], RepaymentConfirmation.prototype, "caseRepaymentService", void 0);
    __decorate([
        State
    ], RepaymentConfirmation.prototype, "principalList", void 0);
    RepaymentConfirmation = __decorate([
        Auth(110),
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange,
                SelectDepartment: SelectDepartment,
                RepaymentConfirmationDetail: RepaymentConfirmationDetail
            }
        })
    ], RepaymentConfirmation);
    return RepaymentConfirmation;
}(Vue));
export default RepaymentConfirmation;
